import { render, staticRenderFns } from "./Manifestazioni.vue?vue&type=template&id=682aaeee&"
import script from "./Manifestazioni.vue?vue&type=script&lang=js&"
export * from "./Manifestazioni.vue?vue&type=script&lang=js&"
import style0 from "./Manifestazioni.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports